var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoldBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 22.9555C2.25 24.1216 2.81479 25.2154 3.76548 25.8906L15.9155 34.5196C17.1638 35.4061 18.8362 35.4061 20.0845 34.5196L32.2345 25.8906C33.1852 25.2154 33.75 24.1216 33.75 22.9555V3.6C33.75 1.61178 32.1382 9.53674e-07 30.15 9.53674e-07H18H5.85C3.86178 9.53674e-07 2.25 1.61178 2.25 3.6V22.9555Z",
    fill: "#4B5563"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 22.2215C4.5 23.0797 4.90798 23.8868 5.59903 24.3957L16.399 32.3484C17.3512 33.0496 18.6488 33.0496 19.601 32.3484L30.401 24.3957C31.092 23.8868 31.5 23.0797 31.5 22.2215V4.95234C31.5 3.46117 30.2912 2.25234 28.8 2.25234H18H7.2C5.70883 2.25234 4.5 3.46117 4.5 4.95234V22.2215Z",
    fill: "#FFD71B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6151_14439",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 2,
    width: 28,
    height: 31
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 22.2215C4.5 23.0797 4.90798 23.8868 5.59903 24.3957L16.399 32.3484C17.3512 33.0496 18.6488 33.0496 19.601 32.3484L30.401 24.3957C31.092 23.8868 31.5 23.0797 31.5 22.2215V4.95234C31.5 3.46117 30.2912 2.25234 28.8 2.25234H18H7.2C5.70883 2.25234 4.5 3.46117 4.5 4.95234V22.2215Z",
    fill: "#FFD71B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6151_14439)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.3789,
    y: -12.1484,
    width: 5.02277,
    height: 44.2004,
    transform: "rotate(60 28.3789 -12.1484)",
    fill: "#FFFC77"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30078 21.9044C6.30078 22.3254 6.49717 22.7223 6.83185 22.9777L17.1819 30.8751C17.6655 31.2441 18.3361 31.2441 18.8197 30.8751L29.1697 22.9777C29.5044 22.7223 29.7008 22.3254 29.7008 21.9044V5.4C29.7008 4.65442 29.0964 4.05 28.3508 4.05H18.0008H7.65078C6.9052 4.05 6.30078 4.65441 6.30078 5.4V21.9044Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44922 13.5H26.5492L17.9992 23.85L9.44922 13.5Z",
    fill: "#FFCC1B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44922 13.5H15.2992L17.9992 23.85L9.44922 13.5Z",
    fill: "#FEE667"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7 13.5H26.55L18 23.85L20.7 13.5Z",
    fill: "#FEA912"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1492 9.89844H23.8492L26.5492 13.4984H9.44922L12.1492 9.89844Z",
    fill: "#FECD1B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8492 9.89844L26.5492 13.4984H20.6992L23.8492 9.89844Z",
    fill: "#DE8C02"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1508 9.89844L9.45078 13.4984H15.3008L12.1508 9.89844Z",
    fill: "#FFAA13"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9992 9.89844L15.2992 13.4984H20.6992L17.9992 9.89844Z",
    fill: "#FEE667"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0723 12.8633L23.0581 13.065L23.8109 12.3974L23.6092 13.3832L24.2768 14.1361L23.291 13.9343L22.5381 14.6019L22.7399 13.6161L22.0723 12.8633Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldBadge);
export default __webpack_public_path__ + "static/media/goldBadge.868239c3559f7a3f8578c76e9fee72f7.svg";
export { ForwardRef as ReactComponent };